import { Icon } from '@/components/foundations';
import { useCopy } from '@/components/forms';
import { CopyToast } from '@/components/feedback/CopyToast';

export type CheckoutStatusBarProps = {
  status?: 'published';
  /** URL pública, sem `https://`. */
  url: string;
};

/** Status do checkout (Publicado) + URL com botão de copiar (mesmo `useCopy` do `CopyField`). */
export function CheckoutStatusBar({ url }: CheckoutStatusBarProps) {
  const { copied, copy } = useCopy();
  return (
    <div className="ck-meta">
      <div className="m"><span>Status do checkout</span><div className="pill-pub">Publicado</div></div>
      <div className="m">
        <span>URL do checkout</span>
        <div className="urlbox">
          {url}
          <button type="button" id="copyurl" onClick={() => copy(`https://${url}`)} aria-label="Copiar URL" style={copied ? { color: '#17996a' } : undefined}><Icon name="copy" /></button>
          <CopyToast show={copied} />
        </div>
      </div>
    </div>
  );
}
